import * as Sentry from "@sentry/react"
import { some } from "lodash-es"

import { NotFoundException, RpcException, RpcTimeoutException } from "@/lib/client/types.ts"
import { NotAuthenticatedError } from "@/lib/oauth/AuthController.ts"

import type { RouterType } from "@/context.ts"

export function initSentry(router: RouterType) {
  if (window.parent !== window) return

  const ignoredExceptions = [
    "AbortError: The user aborted a request.",
  ]

  Sentry.init({
    dsn: "https://0d4914b32698d3b315f2eab7fcf3db45@o245151.ingest.us.sentry.io/4508913468243968",
    enabled: import.meta.env.PROD,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
    ],
    tracesSampleRate: 1.0,
    beforeSend(event, hint) {
      const e = event.exception
      const oe = hint.originalException

      if (oe instanceof NotFoundException || oe instanceof RpcException || oe instanceof RpcTimeoutException || oe instanceof NotAuthenticatedError) {
        return null
      }

      if (e && e.values && e.values.length > 0) {
        const message = e.values[0].value
        if (message && some(ignoredExceptions, (it) => message.includes(it))) {
          return null
        }
      }

      return event
    }
  })
}
